import { render, staticRenderFns } from "./configureProject.vue?vue&type=template&id=634b55a7&scoped=true"
import script from "./configureProject.vue?vue&type=script&lang=js"
export * from "./configureProject.vue?vue&type=script&lang=js"
import style0 from "./configureProject.vue?vue&type=style&index=0&id=634b55a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b55a7",
  null
  
)

export default component.exports